import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import React from "react";
import { twMerge } from "tailwind-merge";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}
const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, totalSteps }) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className="mb-4 flex items-center">
      {[...Array(totalSteps)].map((_, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber <= currentStep;
        return (
          <div
            key={stepNumber}
            className={twMerge(
              "mr-2 h-2.5 min-w-[48px] max-w-fit truncate rounded-full p-0 text-xs font-medium",
              isCompleted
                ? twMerge(theme.home.tailwind.greenBg, theme.uwhcAssistant.sendText)
                : twMerge(theme.balticQuestionnaire.dividerBg, theme.uwhcAssistant.text),
            )}
          >
            {/* {stepNumber} */}
          </div>
        );
      })}
      <div className="ml-2 text-sm">
        {currentStep} / {totalSteps}
      </div>
    </div>
  );
};

export default StepIndicator;
